<!-- Estado: Activa (se muestra ANTES del label Mañana/Tarde/Noche) -->
<div *ngIf="!isEnded" class="d-flex align-items-center mb-4" style="gap: 15px;">
  <img
    style="width: 140px; height: 90px; object-fit: contain;"
    [src]="dato?.item?.provider?.logo"
    alt=""
  />

  <div class="pl-5 w-100 d-flex align-items-center" style="background-color: #EFFEF9; border-radius: 4px; height: 90px;">
    <h3 style="
      font-size: 18px;
      font-family: 'Lato';
      font-weight: 600;
      color: #000000;
      line-height: 1.2;
      margin-bottom: 0;
    ">
      Tu asistencia al viajero <b>{{ dato?.item.title }}</b> está <span style="color: #28a745; font-weight: 700;">activa</span></h3>
  </div>
</div>

<!-- Estado: Finalizó (se muestra DESPUÉS del checkout) -->
<div *ngIf="isEnded" class="d-flex align-items-center mb-2" style="gap: 15px;">
  <img
    style="width: 140px; height: 90px; object-fit: contain;"
    [src]="dato?.item?.provider?.logo"
    alt=""
  />

  <div class="pl-5 w-100 d-flex align-items-center" style="background-color: #FFD9E0; border-radius: 4px; height: 90px;">
    <h3 style="
      font-size: 18px;
      font-family: 'Lato';
      font-weight: 600;
      color: #000000;
      line-height: 1.2;
      margin-bottom: 0;
    ">
      Tu asistencia al viajero <b>{{ dato?.item.title }}</b> <span style="color: #fe2e54; font-weight: 700;"> finalizó</span></h3>
  </div>
</div>
